const material3 = {
  color: {
    primary: '#2F679C',
    primaryDark: '#154775',
    primaryLight: '#D3E4F6',
    onPrimary: '#FFFFFF',
    secondary: '#B0003A',
    secondaryContainer: '#FFD9E2',
    onSecondaryContainer: '#3F0012',
    surface: '#FFFBFE',
    surfaceContainerLowest: '#FFFFFF',
    surfaceContainerLow: '#F7F9FC',
    surfaceContainer: '#EEF4FA',
    surfaceContainerHigh: '#E6EEF7',
    outline: '#C4D0DC',
    outlineVariant: '#DCE5EF',
    textPrimary: '#1B1B1F',
    textSecondary: '#565E66',
  },
  shape: {
    extraSmall: '4px',
    small: '8px',
    medium: '12px',
    large: '16px',
    extraLarge: '24px',
  },
  elevation: {
    level0: 'none',
    level1: '0 1px 2px rgba(21, 71, 117, 0.08), 0 1px 3px rgba(21, 71, 117, 0.08)',
    level2: '0 2px 6px rgba(21, 71, 117, 0.10), 0 4px 12px rgba(21, 71, 117, 0.08)',
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    titleWeight: 700,
    bodyWeight: 400,
    labelWeight: 600,
  },
};

export default material3;
